var map = {
	"./0.png": 515,
	"./1-0.png": 516,
	"./1-1.png": 1503,
	"./1-2.png": 1504,
	"./1-3.png": 1505,
	"./1.png": 1506,
	"./10.png": 1507,
	"./11.png": 1508,
	"./12.png": 1509,
	"./13.png": 1510,
	"./14.png": 1511,
	"./15.png": 1512,
	"./16.png": 1513,
	"./17.png": 1514,
	"./18.png": 1515,
	"./19.png": 1516,
	"./2.png": 1517,
	"./20.png": 1518,
	"./21.png": 1519,
	"./22.png": 1520,
	"./23.png": 1521,
	"./25.png": 1522,
	"./26.png": 1523,
	"./27.png": 1524,
	"./3.png": 1525,
	"./4.png": 1526,
	"./5.png": 1527,
	"./6.png": 1528,
	"./7.png": 1529,
	"./8.png": 1530,
	"./9.png": 1531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1502;